import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { applicationHistory } from '../../common/application-history';

import { requestAddAlbumToAlbum } from '../../album-view/actions/album-actions';
import { clearSelectedAlbumItems } from '../../album-view/actions/album-item-actions';

import { Dialog } from '../../common/components/dialog';
import AlbumEditContent from '../../album-view/components/dialog/album-edit-content';
import SelectAlbumContent from '../../album-view/components/dialog/select-album-content';
import { startResort } from '../../assetContainer/actions/asset-container-actions';

class AlbumItemViewHeader extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isEditAlbumDialogOpen: false,
			isSelectAlbumDialogOpen: false
		};

		this.bindEditDialog = this.bindEditDialog.bind(this);
		this.openEditAlbumDialog = this.openEditAlbumDialog.bind(this);
		this.closeEditAlbumDialog = this.closeEditAlbumDialog.bind(this);

		this.bindSelectDialog = this.bindSelectDialog.bind(this);
		this.openAlbumSelectDialog = this.openAlbumSelectDialog.bind(this);
		this.closeAlbumSelectDialog = this.closeAlbumSelectDialog.bind(this);
	}

	bindEditDialog(editDialog) {
		if (!editDialog) return;
		this.editAlbumDialog = editDialog;
	}

	openEditAlbumDialog() {
		this.setState({ isEditAlbumDialogOpen: true });
		this.editAlbumDialog.open();
	}

	closeEditAlbumDialog() {
		this.setState({ isEditAlbumDialogOpen: false });
		this.editAlbumDialog.close();
	}

	bindSelectDialog(selectDialog) {
		if (!selectDialog) return;
		this.albumSelectDialog = selectDialog;
	}

	openAlbumSelectDialog() {
		this.setState({ isSelectAlbumDialogOpen: true });
		this.albumSelectDialog.open();
	}

	closeAlbumSelectDialog() {
		this.setState({ isSelectAlbumDialogOpen: false });

		this.albumSelectDialog.close();
	}

	addToAlbum(targetAlbumId) {
		const { addToAlbum, album } = this.props;
		addToAlbum(targetAlbumId, album.id);
	}

	render() {
		const { disableAlbumItemSelectionMode, clearSelectedAlbumItems, enableAlbumItemSelectionMode, album } = this.props;

		return (
			<header className="header-flex-container">
				<div className="header-flex-left">
					<div
						className="header-item-left nav-detail-top-back header-back-button"
						onClick={() => {
							const { clearAlbumItems } = this.props;
							clearAlbumItems();
							clearSelectedAlbumItems();
							disableAlbumItemSelectionMode();
							applicationHistory.push(`/my/albums`);
						}}
					/>
				</div>
				<div className="header-flex-right">

					<div className="header-flex-spacer" />
					{album && album.stats && album.stats.numElements > 0 &&

						<div
							className="header-item header-item-right"
							onClick={() => {
								applicationHistory.push(`${applicationHistory.location.pathname}/arrange`);
							}}>
							<div className="header-icon arrange" />
							<div className="header-label">Arrange</div>
						</div>
					}

				</div>
				<div className="header-flex-right">

					<div className="header-flex-spacer" />
					{album && album.stats && album.stats.numElements > 0 &&
						<div
							className="header-item header-item-right"
							onClick={() => {
								enableAlbumItemSelectionMode();
								applicationHistory.push(`${applicationHistory.location.pathname}/select`);
							}}>
							<div className="header-icon select-white" />
							<div className="header-label">Select</div>
						</div>

					}

				</div>
				{this.state.isEditAlbumDialogOpen &&
					<Dialog title="Album Tags & Information"
						isOpen={this.state.isEditAlbumDialogOpen}
						onClose={() => this.setState({ isEditAlbumDialogOpen: false })}>
						<AlbumEditContent album={album} closeDialog={this.closeEditAlbumDialog} />
					</Dialog>
				}
				{this.state.isSelectAlbumDialogOpen &&
					<Dialog title="Select Album to Add to"
						isOpen={this.state.isSelectAlbumDialogOpen}
						onClose={() => this.setState({ isSelectAlbumDialogOpen: false })}>
						<SelectAlbumContent
							onClose={() => this.setState({ isSelectAlbumDialogOpen: false })}
							album={album}
							selectAlbum={id => this.addToAlbum(id)}
							visible={this.state.isSelectAlbumDialogOpen}
						/>
					</Dialog>
				}
			</header>
		);
	}
}

AlbumItemViewHeader.propTypes = {
	enableAlbumItemSelectionMode: PropTypes.func,
	disableAlbumItemSelectionMode: PropTypes.func,
	clearSelectedAlbumItems: PropTypes.func,
	album: PropTypes.object,
	addToAlbum: PropTypes.func,
	startResort: PropTypes.func,
	clearAlbumItems: PropTypes.func,
	albumItems: PropTypes.array
};

const mapStateToProps = state => {
	return {
		albums: state.albumList.albums,
		album: state.albumItems.parentAlbum,
		albumItems: state.albumItems.albumItems
	};
};

const mapDispatchToProps = dispatch => {
	return {
		addToAlbum: (targetAlbumId, sourceAlbumId) => {
			dispatch(requestAddAlbumToAlbum(dispatch, targetAlbumId, sourceAlbumId));
		},
		clearSelectedAlbumItems: () => dispatch(clearSelectedAlbumItems),
		startResort: (originalValues) => dispatch(startResort(originalValues)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AlbumItemViewHeader);



// WEBPACK FOOTER //
// ./src/header/components/album-item-view-header.jsx